import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth.tsx';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import FacilitiesPage from './pages/FacilitiesPage';
import FacilityDetailsPage from './pages/FacilityDetailsPage';
import EquipmentPage from './pages/EquipmentPage';
import InspectionsPage from './pages/InspectionsPage';
import TrainingPage from './pages/TrainingPage';
import ReportsPage from './pages/ReportsPage';

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />

                    {/* Protected Routes */}
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <DashboardPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/facilities"
                        element={
                            <ProtectedRoute>
                                <FacilitiesPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/facilities/:id"
                        element={
                            <ProtectedRoute>
                                <FacilityDetailsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/equipment"
                        element={
                            <ProtectedRoute>
                                <EquipmentPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/inspections"
                        element={
                            <ProtectedRoute>
                                <InspectionsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/training"
                        element={
                            <ProtectedRoute>
                                <TrainingPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/reports"
                        element={
                            <ProtectedRoute>
                                <ReportsPage />
                            </ProtectedRoute>
                        }
                    />

                    {/* Default redirect */}
                    <Route path="/" element={<Navigate to="/login" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
